import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>
                    De wereld van cafeïne: een blik op de gezondheidsvoordelen!
                </title>
                <link rel="canonical" href={route("blogs.fifty")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Hallo daar! Vandaag gaan we het hebben over iets waar de meesten van ons niet zonder kunnen - cafeïne. Van je ochtendkoffie tot die energiedrankjes die je helpen de nacht door te komen, cafeïne is overal om ons heen. Maar wat is cafeïne eigenlijk? En is het gezond of niet? Laten we eens duiken in de wereld van cafeïne."
                />
                <meta
                    property="og:description"
                    content="Hallo daar! Vandaag gaan we het hebben over iets waar de meesten van ons niet zonder kunnen - cafeïne. Van je ochtendkoffie tot die energiedrankjes die je helpen de nacht door te komen, cafeïne is overal om ons heen. Maar wat is cafeïne eigenlijk? En is het gezond of niet? Laten we eens duiken in de wereld van cafeïne."
                />
                <meta property="og:url" content={route("blogs.fifty")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="De wereld van cafeïne: een blik op de gezondheidsvoordelen! - WE ARE Personal Training Uden en Schijndel"
                />
                <meta property="og:image" content="/assets/blog/cafeine.jpg" />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh] pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/cafeine.webp"
                                    type="image/webp"
                                    alt="Cafeïne"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/cafeine.jpg"
                                    type="image/jpeg"
                                    alt="Cafeïne"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/cafeine.jpg"
                                    alt="Cafeïne"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        De wereld van cafeïne: een blik op de
                        gezondheidsvoordelen!
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        Hallo daar! Vandaag gaan we het hebben over iets waar de
                        meesten van ons niet zonder kunnen - cafeïne. Van je
                        ochtendkoffie tot die energiedrankjes die je helpen de
                        nacht door te komen, cafeïne is overal om ons heen. Maar
                        wat is cafeïne eigenlijk? En is het gezond of niet?
                        Laten we eens duiken in de wereld van cafeïne.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Wat is cafeïne?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Cafeïne is een natuurlijk stimulerend middel dat
                        voorkomt in verschillende plantensoorten. Het werkt door
                        het centrale zenuwstelsel te stimuleren, waardoor je je
                        alerter en minder moe voelt (Mayo Clinic, 2017). Dat
                        verklaart waarom die eerste slok koffie 's ochtends zo
                        verfrissend aanvoelt!
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Is cafeïne gezond?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Er is veel discussie over de gezondheidseffecten van
                        cafeïne. Sommige studies suggereren dat matige
                        cafeïneconsumptie kan helpen bij het verbeteren van de
                        mentale en fysieke prestaties, het verhogen van de
                        vetverbranding en het verminderen van het risico op
                        bepaalde ziekten zoals Alzheimer en Parkinson (Poole et
                        al., 2017). Echter, te veel cafeïne kan leiden tot
                        slapeloosheid, nervositeit, snelle hartslag en andere
                        problemen (Mayo Clinic, 2017). Dus, zoals bij de meeste
                        dingen, is matiging de sleutel. Onze richtlijn is 4 tot
                        6 milligram cafeïne per kilo lichaamsgewicht.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        In welke voedingsproducten zit veel cafeïne?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Wanneer we het over cafeïne hebben, denken de meesten
                        van ons waarschijnlijk aan koffie. Maar wist je dat er
                        veel andere voedingsproducten zijn die cafeïne bevatten?
                        Thee, chocolade, sommige frisdranken en zelfs bepaalde
                        medicijnen bevatten cafeïne (Mitchell et al., 2014). Dus
                        als je probeert je cafeïne-inname te beperken, is het
                        belangrijk om deze andere bronnen in gedachten te
                        houden.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Het verschil tussen snelle en trage cafeïne
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Wist je dat niet alle cafeïne hetzelfde is? Er is een
                        verschil tussen wat we 'snelle' en 'trage' cafeïne
                        noemen. Snelle cafeïne, zoals die in energiedrankjes en
                        koffie, komt snel in je systeem en geeft je een snelle
                        energieboost. Trage cafeïne, zoals die in thee, komt
                        langzamer in je systeem en geeft je een meer
                        geleidelijke energieboost (Liguori et al., 1997). Dus
                        afhankelijk van wat je nodig hebt, kun je kiezen voor
                        snelle of trage cafeïne.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        We hopen dat dit je een beter inzicht heeft gegeven in
                        de wereld van cafeïne. Onthoud, zoals bij alles, is
                        matiging de sleutel. Dus geniet van je ochtendkoffie,
                        maar vergeet niet om ook andere bronnen van cafeïne in
                        de gaten te houden. En vergeet niet, er is altijd tijd
                        voor een kopje thee!
                    </p>
                    {/* -- */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl">
                        Bibliografie
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        De informatie in dit artikel is gebaseerd op betrouwbare
                        bronnen uit de literatuur.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Mayo Clinic. (2017). Caffeine: How much is too much?
                        <a
                            href="https://www.mayoclinic.org/healthy-lifestyle/nutrition-and-healthy-eating/in-depth/caffeine/art-20045678"
                            className="text-we-are-yellow"
                            target="_blank"
                        >
                            https://www.mayoclinic.org/healthy-lifestyle/nutrition-and-healthy-eating/in-depth/caffeine/art-20045678
                        </a>
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Mitchell, D. C., Knight, C. A., Hockenberry, J.,
                        Teplansky, R., & Hartman, T. J. (2014). Beverage
                        caffeine intakes in the U.S. Food and Chemical
                        Toxicology, 63, 136–142.
                        <a
                            href="https://doi.org/10.1016/j.fct.2013.10.042"
                            className="text-we-are-yellow"
                            target="_blank"
                        >
                            https://doi.org/10.1016/j.fct.2013.10.042
                        </a>
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Poole, R., Kennedy, O. J., Roderick, P., Fallowfield, J.
                        A., Hayes, P. C., & Parkes, J. (2017). Coffee
                        consumption and health: umbrella review of meta-analyses
                        of multiple health outcomes. BMJ, 359, j5024.
                        <a
                            href="https://doi.org/10.1136/bmj.j5024"
                            className="text-we-are-yellow"
                            target="_blank"
                        >
                            https://doi.org/10.1136/bmj.j5024
                        </a>
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Liguori, A., Hughes, J. R., & Grass, J. A. (1997).
                        Absorption and subjective effects of caffeine from
                        coffee, cola and capsules. Pharmacology Biochemistry and
                        Behavior, 58(3), 721-726.
                        <a
                            href="https://doi.org/10.1016/S0091-3057(97)00003-8"
                            className="text-we-are-yellow"
                            target="_blank"
                        >
                            https://doi.org/10.1016/S0091-3057(97)00003-8
                        </a>
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
